var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useGetFileToDownloadQuery } from "@/store/api";
import { faDownload } from "@fortawesome/pro-solid-svg-icons";
import { useEffect, useState } from "react";
import { downloadConfirm } from "@/components/fields/file/detail";
import { usePopup } from "@/hooks/layout";
var ActionDownload = function (_a) {
    var record = _a.record, moduleName = _a.moduleName;
    var values = record.document_name || "";
    var id = record.document_revision_id || "";
    var _b = useState(""), dataFile = _b[0], setDataFile = _b[1];
    var _c = useGetFileToDownloadQuery({
        params: {
            id: id,
            type: moduleName,
            isTempFile: false,
            tempName: values,
            isRecordFile: true,
        },
    }), file = _c.data, error = _c.error;
    useEffect(function () {
        try {
            if (error) {
                throw new Error("error fetching file");
            }
            if (file && file.data && file.data.output) {
                setDataFile(file.data.output);
            }
            else {
                throw new Error("Output URL not found!");
            }
        }
        catch (error) {
            console.log("Error:", error);
        }
    }, [file, values, error]);
    var _d = usePopup(), showPopup = _d.showPopup, closePopup = _d.closePopup;
    return (_jsx("div", __assign({ className: "flex flex-row" }, { children: _jsx(_Fragment, { children: _jsx(FontAwesomeIcon, { icon: faDownload, className: "text-gray-300  hover:text-gray-500 m-1 cursor-pointer", onClick: function () {
                    dataFile &&
                        downloadConfirm(dataFile, values, showPopup, closePopup);
                } }) }) })));
};
export default ActionDownload;
